import { Col } from "antd";
import styled from "styled-components";

export const WatchSettingRoot = styled(Col)`
  padding-left: 1vw;
  padding-top: 1vh;
  padding-bottom: 3vh;
`;
